import { Box } from '@zoopla-eng/zds-components/box';
import { Skeleton } from '@zoopla-eng/zds-components/skeleton';
import ListingCard from '@zoopla/listing-card';
import { VisuallyHidden } from '@zoopla-eng/zds-components/visually-hidden';
import { listStyle, listItemStyle } from './NewHomesListings.styles.css';
import {
    containerStyle,
    grid1Style,
    grid2Style,
    gridItemStyle,
    gridItem2Style,
    gridItem3Style,
    gridItem4Style
} from './NewHomesListingSkeleton.styles.css';

export const NewHomesListingSkeleton = () => (
    <div className={containerStyle}>
        <Box px="S400" pt="S200">
            <div className={grid1Style}>
                {[
                    <div
                        className={gridItemStyle}
                        key="development-details-listing-skeleton-00"
                    >
                        <Skeleton.Wave curved />
                    </div>
                ]}
            </div>
        </Box>
        <ul className={listStyle} style={{ overflow: 'hidden' }}>
            {[...Array(4).keys()].map((index) => {
                return (
                    <li
                        className={listItemStyle}
                        key={`development-details-listing-skeleton-${index}`}
                        aria-hidden="true"
                    >
                        <ListingCard.LayoutLandscapeMini>
                            <ListingCard.LayoutMedia>
                                <Skeleton.Wave />
                            </ListingCard.LayoutMedia>
                            <ListingCard.LayoutContent>
                                <Box p="S200" height="100%">
                                    <div className={grid2Style}>
                                        <div className={gridItem2Style}>
                                            <Skeleton.Wave curved />
                                        </div>
                                        <div className={gridItem3Style}>
                                            <Skeleton.Wave curved />
                                        </div>
                                        <div className={gridItem4Style}>
                                            <Skeleton.Wave curved />
                                        </div>
                                    </div>
                                </Box>
                            </ListingCard.LayoutContent>
                        </ListingCard.LayoutLandscapeMini>
                    </li>
                );
            })}
        </ul>
        <VisuallyHidden>Loading</VisuallyHidden>
    </div>
);
